import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "vant/lib/index.css";
import "@/assets/css/element-variables.scss";
import "@/assets/css/base.scss";
import "@/utils/nativeMethodEx";
import basePlugins from "@/plugins/base";
import formDialog from "@/plugins/formDialog";
import { Message } from "element-ui";
import KeepAliveEx from "@/components/keepAlive/keepAliveEx";
import tooltipAutoShow from "@/plugins/tooltipAutoShow";
import i18n from "./lang";
import "@/iconfont/iconfont.css";
import "babel-polyfill";

import Es6Promise from "es6-promise";
import "es6-promise/auto";
Es6Promise.polyfill();
// import * as echarts from "echarts";
Vue.config.productionTip = false;
Vue.use(ElementUI).use(basePlugins).use(formDialog);
Vue.component("KeepAliveEx", KeepAliveEx);
Vue.directive("tooltip-auto-show", tooltipAutoShow);

Vue.prototype.$message = function (msg) {
  return Message({
    message: msg,
    duration: 1200,
  });
};
Vue.prototype.$message.success = function (msg) {
  return Message.success({
    message: msg,
    duration: 1200,
  });
};
Vue.prototype.$message.warning = function (msg) {
  return Message.warning({
    message: msg,
    duration: 1200,
  });
};
Vue.prototype.$message.error = function (msg) {
  return Message.error({
    message: msg,
    duration: 1200,
  });
};

const vm = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

// 应用初始化后，更新 index.html 的 title
document.title = i18n.t("main.title");

// 监听语言切换，实时更新 title
vm.$watch(
  "$i18n.locale",
  (newLocale) => {
    document.title = i18n.t("main.title"); // 语言切换后更新标题
  },
  { immediate: false }
); // immediate 设为 false 避免初始化时重复执行

let beginTime = 0;
// 1. load事件：首次加载、刷新都会触发
window.addEventListener("unload", (e) => {
  let endTime = Date.now();
  let duration = endTime - beginTime;
  if (duration < 5) {
    // 小于1秒，认为是刷新，不执行关闭逻辑
    localStorage.removeItem("accountInfo");
  }
});

// 2. beforeunload事件：刷新、关闭前都会触发
window.addEventListener("beforeunload", (e) => {
  beginTime = Date.now();
});
